import React, { useState, useEffect } from 'react';
import CreateEditPriestPackageModal from './CreateEditPriestPackageModal';
import PriestPackageView from './PriestPackageView';
import styles from './PriestPackageComponent.module.css';
import { getPriestEventspackage } from '../../Apiservices/Auth/servers/fetchProviderData';
import { fetchCategoryEvents } from '../../Apiservices/Auth/servers/fetchCategoryEvents';
import { getPriestEvents } from '../../Apiservices/Auth/servers/fetchProviderData';
const PriestPackageComponent = ({ onSave }) => {
  const [mode, setMode] = useState('view'); // 'view', 'create', 'edit'
  const [packages, setPackages] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [recomendedevents,setrecomendedevents] = useState([])

  // Fetch packages on component mount
  useEffect(() => {
    fetchPackages();
  }, []);

  const fetchPackages = async () => {
    setLoading(true);
    try {
      const response = await getPriestEventspackage();
      const recomendedevents = await fetchCategoryEvents()
      const priestevents = await getPriestEvents()
      console.log("recomendedevents",recomendedevents,priestevents)
         const extractedEvents = [];
    
    if (Array.isArray(priestevents)) {
      priestevents.forEach(category => {
        if (category.events && Array.isArray(category.events)) {
          category.events.forEach(event => {
            extractedEvents.push({
              id: event.id,
              name: event.name
            });
          });
        }
      });
    }
    
    console.log("Extracted events:", extractedEvents);
      setrecomendedevents(extractedEvents)
      if (response && response.data && response.data.success === true) {
      // The data is in response.data.data
      const packagesData = response.data.data;
      setPackages(packagesData);
      
    } else {
      console.error("Failed to fetch packages - invalid response structure");
    }
    } catch (error) {
      console.error('Failed to fetch packages:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCreateNew = () => {
    setSelectedPackage(null);
    setMode('create');
  };

  const handleEdit = (pkg) => {
      console.log("Editing package data:", pkg);
    setSelectedPackage(pkg);
    setMode('edit');
  };

  const handleCancel = () => {
    setMode('view');
    setSelectedPackage(null);
  };

  const handleSave = async (savedPackage) => {
  console.log('🔄 handleSave called with package:', savedPackage);
  
  try {
    // Refresh packages list
    console.log('📦 Fetching updated packages...');
    await fetchPackages();
    
    // Call parent onSave callback if provided
    if (onSave) {
      console.log('📤 Calling parent onSave...');
      onSave(savedPackage);
    }
    
    // Return to view mode
    console.log('👁️ Setting mode to view...');
    setMode('view');
    setSelectedPackage(null);
    console.log('✅ Mode changed to view successfully');
    
  } catch (error) {
    console.error('❌ Error in handleSave:', error);
    // Still return to view mode even if there's an error
    setMode('view');
    setSelectedPackage(null);
  }
};

  const handleDelete = async (packageId) => {
    // Refresh packages list after deletion
    await fetchPackages();
  };

  if (loading) {
    return (
      <div className={styles.loadingContainer}>
        <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem', color: '#0cc0df' }}></i>
        <p>Loading packages...</p>
      </div>
    );
  }

  return (
    <div className={styles.packageSection}>
      {mode === 'view' ? (
        <PriestPackageView
          packages={packages}
          onCreateNew={handleCreateNew}
          onEdit={handleEdit}
          onDelete={handleDelete}
          recommendedEvents={recomendedevents}
        />
      ) : (
        <CreateEditPriestPackageModal
          mode={mode}
          packageData={selectedPackage}
          onSave={handleSave}
          onCancel={handleCancel}
          recommendedEvents={recomendedevents}
        />
      )}
    </div>
  );
};

export default PriestPackageComponent;